import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Play } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { GAME_CARD_IMG } from "@/lib/api";

export default function Home() {
  const { user, openAuth } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const ref = params.get("ref");
    if (ref) {
      localStorage.setItem("xver_ref", ref);
      if (!user) openAuth("register");
    }
  }, [params]); // eslint-disable-line react-hooks/exhaustive-deps

  const open = () => (user ? nav("/slide") : openAuth("login"));

  return (
    <div className="flex flex-col items-center pt-2 sm:pt-6">
      <button
        data-testid="home-game-card"
        onClick={open}
        className="group relative w-full max-w-[460px] rounded-2xl overflow-hidden shadow-[0_24px_60px_-18px_rgba(20,117,225,.55)] x-rise"
        style={{ aspectRatio: "1096 / 1436" }}
      >
        <img src={GAME_CARD_IMG} alt="XVER Slide" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]" />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/35 transition-colors duration-300 flex items-center justify-center">
          <div className="opacity-0 group-hover:opacity-100 translate-y-3 group-hover:translate-y-0 transition-[opacity,transform] duration-300 flex flex-col items-center gap-3">
            <div className="w-16 h-16 rounded-full bg-[var(--x-blue)] flex items-center justify-center shadow-xl">
              <Play size={28} fill="white" />
            </div>
            <span className="font-extrabold text-lg">{user ? "Oyna" : "Giriş Yap / Kayıt Ol"}</span>
          </div>
        </div>
      </button>
      <div className="w-full max-w-[460px] mt-4 flex items-center justify-between x-rise" style={{ animationDelay: ".12s" }}>
        <div>
          <div className="text-xl font-extrabold">XVER</div>
          <div className="text-[13px] font-semibold text-[var(--x-muted)]">XVER Orijinal</div>
        </div>
        <button data-testid="home-play-btn" onClick={open} className="x-btn x-btn-primary px-7">
          {user ? "Şimdi Oyna" : "Giriş Yap"}
        </button>
      </div>
    </div>
  );
}
